import type { Session } from '../../../../sessions/types/sessionTypes';
import { Button } from '../../../../../components/ui/button';
import { Trash2 } from 'lucide-react';
import { cn } from '../../../../../lib/utils';
import { formatTimeAgo } from '../../../../sessions/utils/sessionDisplayUtils';

type SessionsSettingsRowProps = {
  session: Session;
  isCurrent: boolean;
  onRequestDelete: () => void;
};

export function SessionsSettingsRow({ session, isCurrent, onRequestDelete }: SessionsSettingsRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 rounded-md border border-border bg-background p-3',
        isCurrent ? 'border-primary/50 bg-primary/5' : undefined
      )}
      data-testid="settings-session-row"
    >
      <div className="min-w-0">
        <div className="flex items-center gap-2 min-w-0">
          <div className="font-medium truncate">{session.name || 'Untitled Session'}</div>
          {session.customName && (
            <span className="text-xs text-muted-foreground" title="Custom name">
              *
            </span>
          )}
        </div>
        <div className="mt-1 text-xs text-muted-foreground">
          {formatTimeAgo(session.lastOpenedAt)}
          {' • '}
          {session.connections.length} conn{session.connections.length === 1 ? '' : 's'}
          {' • '}
          {session.tabs.length} tab{session.tabs.length === 1 ? '' : 's'}
        </div>
      </div>

      {!isCurrent && (
        <Button
          variant="ghost"
          size="icon"
          className="shrink-0 text-muted-foreground hover:text-destructive"
          onClick={onRequestDelete}
          data-testid={`settings-delete-session-button-${session.id}`}
          title="Delete session"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}

